document.addEventListener('DOMContentLoaded', function () {
  

    const items = document.querySelectorAll('[js-category-item]');
    if (items) {
        items.forEach(function (item) {
            item.addEventListener('click', function () {
                items.forEach(function (b_item) {
                    b_item.classList.remove('is-active');
                });
                item.classList.add('is-active');
                let target = item.dataset.target;
                const containers = document.querySelectorAll('.js-category-container');
                containers.forEach(function (container) {
                    container.classList.remove('is-active');
                });

                containers.forEach(function (container) {
                    if (container.classList.contains(target)) {
                        container.classList.add('is-active');
                    }
                });
            });
        });
    }
});